"use client";

import ImpactCards from "./ui/ImpactCards";
import { motion } from "motion/react";
import { SanityImpact } from "@/sanity/lib/types";

interface ImpactProps {
  cards: SanityImpact[];
}

export default function Impact({ cards }: ImpactProps) {
  return (
    <section className="my-20 flex w-full flex-col items-stretch justify-center overflow-hidden px-6 md:my-30 lg:my-40">
      <div className="mx-auto flex w-full flex-col items-center justify-around gap-8 lg:max-w-[1200px]">
        <motion.h2
          className="text-primary z-10 text-center text-4xl/tight font-bold lg:text-5xl"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 1.5 }}
        >
          MAKING IMPACT COUNT
        </motion.h2>

        <ImpactCards cards={cards} />
      </div>
    </section>
  );
}
